import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'


//自定义插件工具
import plugins from "@/plugins";
import store from "@/store"



//自定义组件
import QuEditor from "@/components/Editor/QuEditor.vue";
import FileUpload from "@/components/FileUpload/FileUpload.vue";
import filePreview from "@/components/FilePreview/FilePreview.vue";
import LoginModal from "@/views/LoginModal.vue";
import Pagination  from "@/components/Pagination/Pagination.vue";
import ImageUpload from "@/components/imageUpload/ImageUpload.vue"
import TaskStatus from "@/components/TaskStatus/index.vue"

// 抑制 ResizeObserver 错误
window.addEventListener('error', function (e) {
    if (e.message.includes('ResizeObserver')) {
        e.stopImmediatePropagation();
    }
}, true);

createApp(App)
    .use(router)
    .use(ElementPlus, {
        locale: zhCn, // 核心：设置中文语言包
    })
    .use(plugins)
    .use(store)
    .component('FileUpload', FileUpload)
    .component('ImageUpload', ImageUpload)
    .component('Pagination', Pagination)
    .component('QuEditor', QuEditor)
    .component('FilePreview', filePreview)
    .component('LoginModal', LoginModal)
    .component('TaskStatus', TaskStatus)
    .mount('#app')
